(() => {
  if (customElements.get('marame-cart-costs')) return;

  const moneyCents = (value) => {
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    const match = String(value).match(/^(\d+)(?:\.(\d{1,2}))?$/);
    if (!match) return null;
    const cents = Number(match[1]) * 100 + Number((match[2] || '').padEnd(2, '0'));
    return Number.isSafeInteger(cents) ? cents : null;
  };
  const fingerprint = (cart) => {
    if (!cart || !/^[A-Z]{3}$/.test(cart.currency || '') || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0 || !Array.isArray(cart.items)) return null;
    const lines = cart.items.map((item) => {
      if (typeof item.key !== 'string' || !item.key || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || !Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0) return null;
      return [item.key, item.quantity, item.final_line_price];
    });
    if (lines.some((line) => !line)) return null;
    return JSON.stringify([cart.currency, cart.total_price, lines.sort((a, b) => a[0].localeCompare(b[0]))]);
  };
  const cheapestRate = (rates, currency) => {
    if (!Array.isArray(rates) || !rates.length) return null;
    const prices = rates.map((rate) => {
      if (rate?.currency != null && rate.currency !== currency) return null;
      return moneyCents(rate?.price);
    });
    return prices.some((cents) => cents === null) ? null : Math.min(...prices);
  };
  const merchantShippingRates = {"AE":2400,"AF":2800,"AG":2300,"AI":2300,"AM":2200,"AO":2800,"AR":2300,"AT":1050,"AU":1800,"AW":2300,"AZ":2200,"BB":2300,"BD":2200,"BE":940,"BF":2800,"BH":2200,"BI":2800,"BJ":2800,"BN":2200,"BO":2300,"BR":2300,"BS":2300,"BT":2200,"BW":2800,"BZ":2300,"CA":1800,"CH":2300,"CI":2800,"CK":2800,"CL":2300,"CM":2800,"CN":2300,"CO":2300,"CR":2300,"CV":2800,"CY":2800,"CZ":1050,"DE":940,"DJ":2800,"DK":1050,"DM":2300,"DO":2300,"DZ":2200,"EE":1050,"EG":2200,"ER":2800,"ES":1050,"ET":2800,"FI":1050,"FR":940,"GA":2800,"GE":2200,"GF":2300,"GH":2800,"GI":1050,"GL":2800,"GM":2800,"GN":2800,"GR":1050,"GT":2300,"GY":2300,"HK":2300,"HN":2300,"HR":1050,"HT":2300,"ID":2800,"IE":940,"IL":2200,"IN":2200,"IT":1050,"JM":2300,"JO":2200,"JP":2300,"KE":2800,"KG":2800,"KH":2800,"KN":2300,"KR":2800,"KW":2200,"KZ":2800,"LA":2800,"LB":2200,"LC":2300,"LI":2300,"LK":2200,"LR":2800,"LS":2800,"LT":1050,"LU":940,"LV":1050,"LY":2200,"MA":2200,"MC":940,"MF":2300,"MG":2800,"ML":2800,"MN":2800,"MO":2800,"MQ":2300,"MR":2800,"MS":2300,"MU":2800,"MV":2800,"MW":2800,"MX":2300,"MY":2800,"MZ":2800,"NA":2800,"NE":2800,"NG":2800,"NI":2300,"NL":940,"NO":2300,"NP":2200,"NZ":1800,"OM":2200,"PA":2300,"PE":2300,"PF":2800,"PG":2800,"PH":2800,"PK":2200,"PL":1050,"PT":1050,"PY":2300,"QA":2200,"RE":2800,"RO":1050,"RW":2800,"SA":2200,"SC":2800,"SE":1050,"SG":2400,"SI":1050,"SK":1050,"SN":2800,"SR":2300,"SV":2300,"SY":2800,"TC":2300,"TD":2800,"TG":2800,"TH":2800,"TM":2800,"TN":2200,"TO":2800,"TT":2300,"TW":2800,"TZ":2800,"UG":2800,"US":1069,"UY":2300,"UZ":2800,"VG":2300,"VN":2800,"VU":2800,"WF":2800,"YE":2200,"ZA":2300,"ZM":2800,"ZW":2800};
  const possibleFreeShipping = [{"countries":["AU"],"currency":"AUD","minimum":60000},{"countries":["CA"],"currency":"CAD","minimum":70000},{"countries":["BE","FR","DE","IE","LU","MC","NL","AT","HR","CZ","DK","EE","FI","GI","GR","LV","LT","PL","PT","RO","SK","SI","ES","SE","IT","LI","NO","CH"],"currency":"EUR","minimum":40000},{"countries":["NZ"],"currency":"NZD","minimum":70000},{"countries":["SG"],"currency":"SGD","minimum":50000},{"countries":["AE"],"currency":"AED","minimum":150000},{"countries":["US"],"currency":"USD","minimum":50000}];
  const merchantEstimate = (country, currency, storeCurrency, presentment, total) => {
    if (storeCurrency !== 'GBP' || !/^[A-Z]{2}$/.test(country || '') || !/^[A-Z]{3}$/.test(currency || '')) return null;
    const rate = merchantShippingRates[country];
    if (!Number.isSafeInteger(rate) || rate < 0) return null;
    if (!Number.isSafeInteger(total) || total < 0) return null;
    if (possibleFreeShipping.some((rule) => rule.currency === currency && rule.countries.includes(country) && total >= rule.minimum)) return null;
    let exchange = 1;
    if (currency !== storeCurrency) {
      if (presentment?.active !== currency || !/^(?:\d+\.?\d*|\.\d+)$/.test(String(presentment?.rate || ''))) return null;
      exchange = Number(presentment.rate);
      if (!Number.isFinite(exchange) || exchange <= 0) return null;
    }
    const converted = Math.round(rate * exchange);
    return Number.isSafeInteger(converted) && converted >= 0 ? converted : null;
  };

  const elements = new Set();
  const coordinator = {
    tail: Promise.resolve(),
    enqueue(job) {
      const pending = this.tail.catch(() => {}).then(job);
      this.tail = pending.catch(() => {});
      return pending;
    },
    invalidate() { elements.forEach((element) => element.invalidate(true)); }
  };
  const captureCartChange = (event) => {
    const selector = event.type === 'click'
      ? 'cart-remove-button, .quantity__button, button[name="add"]'
      : 'cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"], .quantity__input';
    if (event.target?.closest?.(selector)) coordinator.invalidate();
  };
  let unsubscribe;
  const onCartChange = () => coordinator.invalidate();
  const onCartUpdate = (event) => {
    const updated = fingerprint(event?.cartData);
    elements.forEach((element) => {
      if (!updated || updated !== element.initialFingerprint) element.invalidate(true);
      else if (element.recalculating && !element.loading) { element.invalidate(); if (element.isOpen()) element.load(); }
    });
  };
  const onHide = () => elements.forEach((element) => element.invalidate());
  const onRestore = () => { elements.forEach((element) => { element.invalidate(); if (element.isOpen()) element.load(); }); };
  const onVisibility = () => { if (document.visibilityState === 'hidden') onHide(); else onRestore(); };
  const installListeners = () => {
    document.addEventListener('input', captureCartChange, true);
    document.addEventListener('change', captureCartChange, true);
    document.addEventListener('click', captureCartChange, true);
    document.addEventListener('cart:lines-update', onCartChange);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('pageshow', onRestore);
    window.addEventListener('pagehide', onHide);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  };
  const removeListeners = () => {
    document.removeEventListener('input', captureCartChange, true);
    document.removeEventListener('change', captureCartChange, true);
    document.removeEventListener('click', captureCartChange, true);
    document.removeEventListener('cart:lines-update', onCartChange);
    document.removeEventListener('visibilitychange', onVisibility);
    window.removeEventListener('pageshow', onRestore);
    window.removeEventListener('pagehide', onHide);
    unsubscribe?.();
    unsubscribe = undefined;
  };

  class MarameCartCosts extends HTMLElement {
    static fingerprint = fingerprint;
    static moneyCents = moneyCents;
    static cheapestRate = cheapestRate;
    static merchantEstimate = merchantEstimate;

    connectedCallback() {
      if (this.ready) return;
      this.setState('connecting');
      this.drawer = this.closest('cart-drawer');
      if (!this.drawer || this.dataset.requiresShipping !== 'true') { this.setState('not-shipping-drawer'); return; }
      try { this.config = JSON.parse(this.querySelector('[data-cost-config]')?.textContent || '{}'); } catch { this.setState('invalid-json'); return; }
      const standard = this.dataset.ukDefaultCents;
      this.merchantStandard = this.dataset.domestic === 'true' && this.dataset.country === 'GB' && this.config.cart?.currency === 'GBP' && /^\d+$/.test(standard || '') && Number.isSafeInteger(Number(standard));
      this.labels = this.config.labels || {};
      this.initialFingerprint = fingerprint(this.config.cart);
      this.nodes = {};
      for (const name of ['shipping', 'shipping-label', 'total', 'total-label', 'estimate-note']) this.nodes[name] = this.querySelector(`[data-cost-${name}]`);
      if (!this.initialFingerprint || !this.nodes.shipping || !this.nodes.total || !this.nodes['total-label'] || typeof fetch !== 'function' || typeof AbortController !== 'function' || typeof MutationObserver !== 'function') { this.setState('invalid-config'); return; }
      this.initialTotal = this.nodes.total.textContent;
      this.initialLabel = this.nodes['total-label'].textContent;
      this.initialNote = this.nodes['estimate-note']?.textContent || '';
      this.initialShipping = this.nodes.shipping.textContent;
      this.initialShippingLabel = this.nodes['shipping-label']?.textContent || this.labels.shipping || '';
      this.run = 0;
      this.ready = true;
      this.lastOpen = this.isOpen();
      this.observer = new MutationObserver(() => {
        const open = this.isOpen();
        if (open === this.lastOpen) return;
        this.lastOpen = open;
        if (open) this.load(); else this.invalidate();
      });
      this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
      if (!elements.size) installListeners();
      elements.add(this);
      this.setState(this.merchantStandard ? 'merchant-standard' : document.visibilityState === 'hidden' ? 'idle-hidden' : 'idle-closed');
      if (this.lastOpen) this.load();
    }

    disconnectedCallback() {
      if (!this.ready) return;
      this.invalidate();
      this.observer?.disconnect();
      elements.delete(this);
      if (!elements.size) removeListeners();
      this.ready = false;
    }

    isOpen() { return this.isConnected && this.drawer?.classList.contains('active') && document.visibilityState !== 'hidden'; }

    setState(value) { this.setAttribute('data-cost-state', value); }

    invalidate(pending = false) {
      this.setState('reset');
      this.clearLoading();
      this.run += 1;
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.expiryTimer);
      this.loading = false;
      this.quotedAt = 0;
      this.nodes.shipping.textContent = this.initialShipping;
      this.nodes.total.textContent = this.initialTotal;
      this.nodes['total-label'].textContent = this.initialLabel;
      if (this.nodes['shipping-label']) this.nodes['shipping-label'].textContent = this.initialShippingLabel;
      if (this.nodes['estimate-note']) this.nodes['estimate-note'].textContent = this.initialNote;
      if (pending && this.isOpen()) this.showLoading();
    }

    clearLoading() {
      clearTimeout(this.pendingTimer);
      this.recalculating = false;
      this.removeAttribute('data-cost-loading');
      this.setAttribute('aria-busy', 'false');
      for (const name of ['shipping', 'total']) this.nodes?.[name]?.removeAttribute('aria-label');
    }

    showLoading() {
      this.clearLoading();
      this.recalculating = true;
      this.setAttribute('data-cost-loading', 'true');
      this.setAttribute('aria-busy', 'true');
      for (const name of ['shipping', 'total']) {
        this.nodes[name].textContent = '…';
        this.nodes[name].setAttribute('aria-label', this.labels.loading || '');
      }
      this.pendingTimer = setTimeout(() => {
        if (!this.recalculating || this.loading) return;
        this.clearLoading();
        this.nodes.shipping.textContent = this.labels.shipping_pending || this.initialShipping;
        this.nodes.total.textContent = this.labels.shipping_pending || this.initialTotal;
        this.setState('update-unconfirmed');
      }, 15000);
    }

    format(cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: this.config.cart.currency, ...(cents % 100 === 0 ? { minimumFractionDigits: 0 } : {}) }).format(cents / 100); }
      catch { return `${(cents / 100).toFixed(cents % 100 === 0 ? 0 : 2)} ${this.config.cart.currency}`; }
    }

    showEstimate(cents, state) {
      const total = this.config.cart.total_price + cents;
      if (!Number.isSafeInteger(total)) return false;
      this.clearLoading();
      this.nodes.shipping.textContent = cents === 0 ? (this.labels.shipping_free || this.format(cents)) : this.format(cents);
      if (this.nodes['shipping-label']) this.nodes['shipping-label'].textContent = this.labels.shipping_estimated || this.initialShippingLabel;
      const included = this.config.merchant_inclusive === true || (this.dataset.taxesIncluded === 'true' && (this.dataset.dutiesIncluded === 'true' || this.dataset.domestic === 'true'));
      this.nodes.total.textContent = included ? this.format(total) : this.initialTotal;
      if (this.nodes['estimate-note']) this.nodes['estimate-note'].textContent = this.labels.estimate_note || this.initialNote;
      this.quotedAt = Date.now();
      this.setState(state);
      clearTimeout(this.expiryTimer);
      this.expiryTimer = setTimeout(() => { this.invalidate(this.isOpen()); if (this.isOpen()) this.load(); }, 300000);
      return true;
    }

    async readCart(url, signal) {
      const controller = new AbortController();
      const stop = () => controller.abort();
      if (signal.aborted) stop();
      signal.addEventListener('abort', stop, { once: true });
      const timeout = setTimeout(stop, 8000);
      try { return await this.request(url, {}, controller.signal); }
      finally { clearTimeout(timeout); signal.removeEventListener('abort', stop); }
    }

    async request(url, options, signal) {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal, headers: { Accept: 'application/json' } });
      if (!response.ok) { const error = new Error('Delivery estimate unavailable'); error.status = response.status; throw error; }
      return response.json();
    }

    async load() {
      if (!this.ready || !this.isOpen() || this.loading || (this.quotedAt && Date.now() - this.quotedAt < 300000)) return;
      if (this.merchantStandard) { this.invalidate(); this.setState('merchant-standard'); return; }
      this.invalidate(true);
      const run = ++this.run;
      const controller = new AbortController();
      this.controller = controller;
      this.removeAttribute('data-cost-http-status');
      const current = () => this.isOpen() && run === this.run && !controller.signal.aborted;
      let countryName = this.dataset.countryName;
      try { countryName = new Intl.DisplayNames(['en'], { type: 'region' }).of(this.dataset.country) || countryName; } catch {}
      if (!/^[A-Z]{2}$/.test(this.dataset.country || '') || !countryName) { this.invalidate(); this.setState('invalid-country'); return; }
      this.loading = true;
      this.setState('queued');
      const root = window.Shopify?.routes?.root || '/';
      const base = root.endsWith('/') ? root : `${root}/`;
      const query = new URLSearchParams({ 'shipping_address[country]': countryName }).toString();
      try {
        await coordinator.enqueue(async () => {
          if (!current()) return;
          const quoteController = new AbortController();
          const stopQuote = () => quoteController.abort();
          controller.signal.addEventListener('abort', stopQuote, { once: true });
          const timeout = setTimeout(stopQuote, 30000);
          try {
            this.setState('before-cart');
            const before = await this.readCart(`${base}cart.js`, controller.signal);
            if (!current()) return;
            if (fingerprint(before) !== this.initialFingerprint) { this.invalidate(); this.setState('cart-mismatch-before'); return; }
            const fallback = merchantEstimate(this.dataset.country, this.config.cart.currency, this.config.store_currency, window.Shopify?.currency, this.config.cart.total_price);
            if (fallback !== null) this.showEstimate(fallback, 'merchant-estimate-pending');
            let result = null;
            let rateError;
            try {
              this.setState(fallback !== null ? 'merchant-estimate-pending' : 'preparing');
              await this.request(`${base}cart/prepare_shipping_rates.json?${query}`, { method: 'POST' }, quoteController.signal);
              for (let attempt = 0; attempt < 10; attempt += 1) {
                if (!current()) return;
                this.setState(fallback !== null ? 'merchant-estimate-pending' : 'polling');
                result = await this.request(`${base}cart/async_shipping_rates.json?${query}`, {}, quoteController.signal);
                if (result !== null) break;
                await new Promise((resolve) => {
                  const done = () => { clearTimeout(timer); quoteController.signal.removeEventListener('abort', done); resolve(); };
                  const timer = setTimeout(done, 1000);
                  if (quoteController.signal.aborted) done();
                  else quoteController.signal.addEventListener('abort', done, { once: true });
                });
              }
            } catch (error) { rateError = error; }
            clearTimeout(timeout);
            if (!current()) return;
            const nativeCents = cheapestRate(result?.shipping_rates, this.config.cart.currency);
            const cents = nativeCents === null ? fallback : nativeCents;
            if (rateError?.status) this.setAttribute('data-cost-http-status', String(rateError.status));
            if (cents === null) {
              this.invalidate();
              this.setState(rateError ? (rateError.status ? 'http-error' : rateError.name === 'AbortError' ? 'request-timeout' : 'request-error') : result === null ? 'rates-timeout' : 'rates-unavailable');
              return;
            }
            this.setState('after-cart');
            const after = await this.readCart(`${base}cart.js`, controller.signal);
            if (!current()) return;
            if (fingerprint(after) !== this.initialFingerprint) { this.invalidate(); this.setState('cart-mismatch-after'); return; }
            if (!this.showEstimate(cents, nativeCents === null ? 'merchant-estimate' : 'quoted')) { this.invalidate(); this.setState('invalid-total'); }
          } finally { clearTimeout(timeout); controller.signal.removeEventListener('abort', stopQuote); }
        });
      } catch (error) {
        if (run === this.run && this.isConnected) {
          this.invalidate();
          this.setState(error.status ? 'http-error' : error.name === 'AbortError' ? 'request-timeout' : 'request-error');
          if (error.status) this.setAttribute('data-cost-http-status', String(error.status));
        }
      } finally {
        if (run === this.run && this.isConnected) { this.loading = false; this.controller = null; }
      }
    }
  }

  customElements.define('marame-cart-costs', MarameCartCosts);
})();


